import styled from "styled-components"

export {
  PageContainer,
  VisualSection,
  FormSection,
  Title,
  InputGroup,
  Label,
  Input,
  Error,
  SubmitButton,
  Logo,
  GridRow,
  TextArea,
  Logo2,
  FormEyebrow,
  FormIntro,
  TrustList,
  DirectContact,
} from "../RequestContactForm/Style"

export const DropdownContainer = styled.div`
  position: relative;
`

export const ChoiceGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem 1.1rem;
  padding: 0.8rem;
  border: 1px solid #c4d0da;
  background: #f6f9fb;

  label {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    color: #3e586d;
    font-size: 0.84rem;
  }
`

export const SectionDivider = styled.div`
  margin: 2.2rem 0 1.2rem;
  padding-top: 1.1rem;
  border-top: 1px solid #c7d3dc;

  strong {
    display: block;
    color: #173953;
    font-size: 1rem;
  }

  span {
    display: block;
    margin-top: 0.25rem;
    color: #6d7f8f;
    font-size: 0.78rem;
  }
`
